/** US Pacific (PST / PDT) for Harbor admin timestamps and calendar buckets. */
export const ADMIN_PACIFIC_TZ = 'America/Los_Angeles';

/** Pacific civil calendar date (YYYY-MM-DD) for an ISO instant. */
export function pacificYmdFromIso(iso: string): string {
  return new Date(iso).toLocaleDateString('en-CA', { timeZone: ADMIN_PACIFIC_TZ });
}

export function formatPacificDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    timeZone: ADMIN_PACIFIC_TZ,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

function pacificCivilAnchor(ymd: string): Date | null {
  const parts = ymd.split('-').map(Number);
  const y = parts[0];
  const m = parts[1];
  const d = parts[2];
  if (!y || !m || !d) return null;
  // 20:00 UTC is always the same Pacific civil date (noon–1pm PT).
  return new Date(Date.UTC(y, m - 1, d, 20, 0, 0));
}

/**
 * Long weekday heading for a Pacific civil date string from {@link pacificYmdFromIso}
 * (not for UTC-midnight ISO dates).
 */
export function formatPacificCivilDateLong(ymd: string): string {
  const anchor = pacificCivilAnchor(ymd);
  if (!anchor) return ymd;
  return anchor.toLocaleDateString(undefined, {
    timeZone: ADMIN_PACIFIC_TZ,
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/** Short calendar label for a Pacific civil YYYY-MM-DD date. */
export function formatPacificCivilDate(
  ymd: string,
  options?: { year?: 'numeric' | '2-digit' }
): string {
  const anchor = pacificCivilAnchor(ymd);
  if (!anchor) return ymd;
  return anchor.toLocaleDateString(undefined, {
    timeZone: ADMIN_PACIFIC_TZ,
    month: 'short',
    day: 'numeric',
    ...(options?.year ? { year: options.year } : {}),
  });
}
